<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<button class="button-link" (click)="initVideo(rowData[fieldDefinition.name])">{{rowData[fieldDefinition.text]}}</button>
